<template>
  <v-container
    class="px-0 py-3"
    fill-height
    fluid
    v-if="!$apollo.queries.myRun.loading"
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        class="px-4"
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.name)"
          @blur="$v.myRun.config.name.$touch()"
          @input="$v.myRun.config.name.$touch()"
          label="Name"
          type="text"
          v-model="myRun.config.name"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-divider></v-divider>
        <v-card class="elevation-0">
          <v-card-title
            class="pt-2 pb-0"
            primary-title
          >
            <div>
              <v-checkbox
                class="pl-1"
                label="Corona"
                v-model="toggleCoronalModel"
              ></v-checkbox>
            </div>
            <v-spacer></v-spacer>
            <div class="pr-2">
              <v-switch
                label="Expert mode"
                v-if="myRun.config.coronal_model.to_run"
                v-model="expertMode"
              ></v-switch>
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panel
              :value="0"
              class="elevation-0"
              v-if="myRun.config.coronal_model.to_run"
            >
              <v-expansion-panel-content>
                <div slot="header">Magnetogram</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputMagnetogram/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content v-show="expertMode">
                <div slot="header">Potential Field Source Surface</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputPFSS/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content v-show="expertMode">
                <div slot="header">Current Sheet</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputSCS/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content v-show="expertMode">
                <div slot="header">Heliospheric Boundary</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputHeliosphereBoundary/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card class="elevation-0">
          <v-card-title
            class="pt-2 pb-0"
            primary-title
          >
            <div>
              <v-checkbox
                class="pl-1"
                label="Heliosphere"
                v-model="toggleHeliosphericModel"
              ></v-checkbox>
            </div>
            <v-spacer></v-spacer>
            <div
              class="pr-2"
              v-if="myRun.config.heliospheric_model.to_run"
            >
              <v-switch
                label="Expert mode"
                v-model="expertMode"
              ></v-switch>
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panel
              :value="0"
              class="elevation-0"
              v-if="myRun.config.heliospheric_model.to_run"
            >
              <v-expansion-panel-content v-if="!myRun.config.coronal_model.to_run">
                <div slot="header">Solar Wind Boundary</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputSolarWindBoundary/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Duration</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputDuration/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Grid</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputGrid/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Coronal Mass Ejections</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputEjections/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Virtual Spacecrafts</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputVirtualSpacecraft/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Plotting</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputPlotting/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>

              <v-expansion-panel-content>
                <div slot="header">Cluster Configuration</div>
                <v-card>
                  <v-card-text class="pa-0">
                    <RunInputCluster/>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="gotoRuns"
              class="ml-0"
              flat
            >Back</v-btn>
            <RunInputSaveButton
              @run-saved="modified=false"
              class="ml-2"
              v-show="modified"
            />
            <RunInputSubmitButton
              class="ml-2"
              v-show="!modified"
            />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RunInputMagnetogram from './RunInput/components/RunInputMagnetogram.vue';
import RunInputPFSS from './RunInput/components/RunInputPFSS.vue';
import RunInputSCS from './RunInput/components/RunInputSCS.vue';
import RunInputHeliosphereBoundary from './RunInput/components/RunInputHeliosphereBoundary.vue';
import RunInputSolarWindBoundary from './RunInput/components/RunInputSolarWindBoundary.vue';
import RunInputDuration from './RunInput/components/RunInputDuration.vue';
import RunInputGrid from './RunInput/components/RunInputGrid.vue';
import RunInputEjections from './RunInput/components/RunInputEjections.vue';
import RunInputVirtualSpacecraft from './RunInput/components/RunInputVirtualSpacecraft.vue';
import RunInputPlotting from './RunInput/components/RunInputPlotting.vue';
import RunInputCluster from './RunInput/components/RunInputCluster.vue';
import RunInputSaveButton from './RunInput/components/RunInputSaveButton.vue';
import RunInputSubmitButton from './RunInput/components/RunInputSubmitButton.vue';

import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  components: {
    RunInputMagnetogram,
    RunInputPFSS,
    RunInputSCS,
    RunInputHeliosphereBoundary,
    RunInputSolarWindBoundary,
    RunInputDuration,
    RunInputGrid,
    RunInputEjections,
    RunInputVirtualSpacecraft,
    RunInputPlotting,
    RunInputCluster,
    RunInputSaveButton,
    RunInputSubmitButton,
  },
  data() {
    return {
      modified: true,
    };
  },
  computed: {
    toggleCoronalModel: {
      get() {
        return this.myRun.config.coronal_model.to_run;
      },
      set(newValue) {
        this.myRun.config.coronal_model.to_run = newValue;
        if (
          !this.myRun.config.coronal_model.to_run &&
          !this.myRun.config.heliospheric_model.to_run
        ) {
          this.myRun.config.heliospheric_model.to_run = true;
        }
      },
    },
    toggleHeliosphericModel: {
      get() {
        return this.myRun.config.heliospheric_model.to_run;
      },
      set(newValue) {
        this.myRun.config.heliospheric_model.to_run = newValue;
        if (
          !this.myRun.config.coronal_model.to_run &&
          !this.myRun.config.heliospheric_model.to_run
        ) {
          this.myRun.config.coronal_model.to_run = true;
        }
      },
    },
  },
  methods: {
    gotoRuns() {
      this.$router.push({ name: 'runs' });
    },
  },
  mounted() {
    this.$store.dispatch('setTitle', 'Run Setup');
  },
  watch: {
    myRun: {
      handler() {
        this.modified = true;
      },
      deep: true,
    },
  },
};
</script>
